import { colorSchemeDark, themeQuartz } from "ag-grid-enterprise";

export const labelingTableTheme = themeQuartz
    .withPart(colorSchemeDark)
    .withParams({
        accentColor: "#6B7280",
        backgroundColor: "#1E293B",
        borderColor: "#334155",
        browserColorScheme: "dark",
        fontFamily: {
            googleFont: "Inter",
        },
        foregroundColor: "#FFFFFF",
        headerFontSize: 14,
        headerVerticalPaddingScale: 1,

        rowHoverColor: "#334155",
        rowBorder: { color: "#0F172A" },
        headerColumnResizeHandleColor: "#475569",
        rowHeight: 42,
    });
